import React from 'react';
import _map from 'lodash.map';
import _filter from 'lodash.filter';
import _orderBy from 'lodash.orderby';
import _includes from 'lodash.includes';
import ReactLoading from 'react-loading';
import { Link } from 'react-router-dom';

// components
import ChecklistHeader from '../components/ChecklistHeader';

import { Container, Header, Grid, List, Segment, Divider, Button, Message } from 'semantic-ui-react';

// React component
class ChecklistsView extends React.Component {
	constructor(props) {
		super(props);

		this.handleToggleView = this.handleToggleView.bind(this);
	}

	handleToggleView(e) {
		e.target.id === 'starred' ? this.props.toggleViewListsToStarred() : this.props.toggleViewListsToAll();
	}

	componentDidMount() {
		// Always fetch all data in this view
		this.props.fetchLists();

		// Get user id from query string
		const parsedUserId = this.props.location.search.slice(8);

		// only fetch data if not already fetched
		// userId must not be empty or undefined
		if (this.props.userLoaded === false && parsedUserId !== '' && typeof parsedUserId !== 'undefined') {
			this.props.fetchUser(parsedUserId);
		}
	}

	render() {
		if (this.props.error) {
			return <div>Error</div>;
		} else if (this.props.loading) {
			return (
				<Grid className="middle aligned">
					<Grid.Row centered>
						<Grid.Column desktop={4} tablet={8} mobile={16}>
							<div className="loading-container row align-center align-middle">
								<ReactLoading
									type="balls"
									color="rgba(40,40,40,0.75)"
									className="react-loading-animation"
									width={100}
								/>
							</div>
						</Grid.Column>
					</Grid.Row>
				</Grid>
			);
		} else {
			let lists = this.props.lists;
			// order lists
			lists = _orderBy(
				lists,
				function(list) {
					return [list['list_id']];
				},
				['desc']
			);
			// filter array based on view
			if (this.props.viewLists === 'starred') {
				lists = _filter(lists, list => {
					return _includes(this.props.user.starredLists, list['list_id']);
				});
			}

			return (
				<Container text id="responsive-container">
					<Grid columns={1}>
						<Grid.Row centered>
							<Grid.Column
								mobile={16}
								tablet={14}
								computer={12}
								id="full-width-col"
								style={{ width: '100% !important' }}
							>
								<Segment raised>
									<Grid className="header-style">
										<Grid.Row>
											<Grid.Column>
												{this.props.showMsgStarredMaximum === true && (
													<Message
														header="Maximum erreicht"
														content="Du kannst maximal sechs Checklisten als Favoriten markieren."
														color="red"
														floating="true"
													/>
												)}
												<Header as="h1" textAlign="center">
													Marlies Checklisten
												</Header>
												<Grid.Row centered textAlign="center" className="centered-row">
													<Button.Group>
														<Button
															primary={this.props.viewLists === 'all' ? true : false}
															size="tiny"
															className="toggleListViews"
															id="all"
															onClick={this.handleToggleView}
														>
															Alle Listen
														</Button>
														<Button
															primary={this.props.viewLists === 'starred' ? true : false}
															size="tiny"
															className="toggleListViews"
															id="starred"
															onClick={this.handleToggleView}
														>
															Meine Listen
														</Button>
													</Button.Group>
												</Grid.Row>
											</Grid.Column>
										</Grid.Row>
									</Grid>

									<List className="list-checklists">
										{// map & print
										_map(lists, list => {
											let listName = list['list_id'];
											let listTitle = list['title'];

											return (
												<div key={listName}>
													<List.Item as={Link} to={`/list/${listName}`}>
														<ChecklistHeader
															listId={listName}
															name={listTitle}
															backButton={false}
															goToButton={true}
														/>
													</List.Item>
													<Divider />
												</div>
											);
										})}
									</List>
								</Segment>
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</Container>
			);
		}
	}
}

export default ChecklistsView;



// WEBPACK FOOTER //
// ./src/views/ChecklistsView.js